<template>
    <div>
        <h1 class="card-title h5">{{ $t('externalBooking.disclaimer.intro') }}</h1>

        <i18n v-if="isAandOVoucher" path="externalBooking.disclaimer.aoHostels" tag="p"
              class="card-text card-auo">
            <template #link>
                <a href="https://voucher.aohostels.com/availability_check.php" target="_blank">{{ $t('externalBooking.disclaimer.aoHostelsLinkText') }}</a>
            </template>
        </i18n>

        <div class="avp-voucher-info alert-info">
            <div class="card-text">{{ $t('externalBooking.disclaimer') }}</div>
            <div v-if="activationData.bookingServiceNotice" class="card-text" v-html="activationData.bookingServiceNotice">
            </div>
        </div>
        <div class="card-navigation justify-content-center justify-content-md-between align-items-start flex-wrap">
            <button type="button" class="btn btn-secondary mb-3 mb-md-0" @click="$store.dispatch('reset')">
                {{ $t('common.redeem_another_voucher') }}
            </button>
            <button v-if="activationData.bookingServiceUrl" @click="startExternalBooking" class="btn btn-primary text-nowrap"
                target="_blank" rel="nofollow">
                {{$t('externalBooking.disclaimer.button.confirm')}}
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'ExternalBookingDisclaimerForm',
    data() {
        return {
            isSendingData: false
        }
    },
    computed: {
        ...mapState(['voucher', 'activationData']),
        ...mapGetters(['voucherCode']),
        isAandOVoucher() {
            const hotelName = (this.$getSafe(this.voucher, 'hotelName') || "").toLowerCase();
            return hotelName.startsWith("a&o") || (this.voucherCode || "").toLowerCase().startsWith("auo");
        }
    },
    methods: {
        async startExternalBooking(){
            try {
                this.isSendingData = true
                await this.$store.dispatch('startExternalBooking', this.voucherCode)
            } finally {
                this.isSendingData = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@use "@/styles/_variables";
@use "sass:map";

.card-auo {
    padding: 10px;
    box-shadow: 0 0.0625rem 0.1875rem 0 rgb(0 0 0 / 20%);
    border-radius: 5px;
    background-color: rgba(map.get(variables.$colors, 'primary'), 0.3);
}
</style>
